export var createEmailTemplatesApi = function (baseUrl, http) {
    return {
        getEmailTemplates: function (dto) {
            return http.get("".concat(baseUrl, "/emailTemplates/").concat(dto.locale).concat(dto.brandId ? "?brandId=".concat(dto.brandId) : ''));
        },
        getEmailTemplate: function (dto) {
            return http.get("".concat(baseUrl, "/emailTemplates/").concat(dto.locale, "/").concat(dto.type).concat(dto.brandId ? "?brandId=".concat(dto.brandId) : ''));
        },
        updateEmailTemplate: function (dto) {
            return http.put("".concat(baseUrl, "/emailTemplates/").concat(dto.locale, "/").concat(dto.type), dto.data);
        },
        getDefaultEmailTemplate: function (dto) {
            return http.get("".concat(baseUrl, "/emailTemplates/").concat(dto.locale, "/").concat(dto.type, "/default").concat(dto.brandId ? "?brandId=".concat(dto.brandId) : ''));
        },
        enableEmailTemplate: function (dto) {
            return http.put("".concat(baseUrl, "/emailTemplates/notifications/").concat(dto.locale, "/").concat(dto.type, "/enable").concat(dto.brandId ? "?brandId=".concat(dto.brandId) : ''), {});
        },
        disableEmailTemplate: function (dto) {
            return http.put("".concat(baseUrl, "/emailTemplates/notifications/").concat(dto.locale, "/").concat(dto.type, "/disable").concat(dto.brandId ? "?brandId=".concat(dto.brandId) : ''), {});
        }
    };
};
//# sourceMappingURL=index.js.map